import { AppImageType } from "./appIcon";

export type AppImageIdentifier = {
	id: number;
	type: AppImageType;
};

export enum RenderImageType {
	Raster = 0,
	Svg = 1,
	ColorizableSvg = 2
}

export type AppImageDisplayInfo = {
	imageUrl: string;
	renderType: RenderImageType;
};
